import * as _ from 'underscore'

import { DataProvider } from "../helpers"

import { OpView } from "../models/core"
import { Enums } from "../models/common"

export class DataProviderView {

    //#region Ctor

    constructor(private dataProvider: DataProvider) { }

    //#endregion


    //#region Public Methods

    public getActiveViews = (): JQueryPromise<OpView[]> => {
        const dictionaryViews: OpView[] = this.dataProvider.LocalStorage.getActiveViews()

        if (dictionaryViews == null || _.size(dictionaryViews) === 0) {
            this.dataProvider
                .sendRequestWithSession('OpxGetActiveView', {}, 'OpxGetActiveViewResult')
                .then((result: any[]) => {
                    const activeViews: OpView[] = result.map((viewObj: any) => new OpView(viewObj))

                    OpView
                        .loadNavigationProperties(this.dataProvider, activeViews)
                        .then(() => {
                            this.dataProvider.LocalStorage.saveLoggedOperatorSetting(Enums.SimaxOperatorSetting.ActiveViews, activeViews)

                            return activeViews
                        })
                })
        }

        return OpView.loadNavigationProperties(this.dataProvider, dictionaryViews)
    }

    /**
     * @deprecated Use only async version.
     */
    public getActiveViewsLocal = (): OpView[] => {
        const activeViews: OpView[] = this.dataProvider.LocalStorage.getActiveViews()

        if (activeViews == null) {
            console.warn("Unable to load views locally.")
        }

        return activeViews
    }

    public getActiveView = (referenceType: Enums.ReferenceType): JQueryPromise<OpView> => {
        return this
            .getActiveViews()
            .then((activeViews: OpView[]) => {
                if (activeViews == null) {
                    return null
                }

                const filterResult: OpView[] = activeViews.filter((activeView: OpView) => activeView.idReferenceType == referenceType)

                return _.first(filterResult) || null
            })
    }

    /**
     * @deprecated Use only async version.
     */
    public getActiveViewLocal = (referenceType: Enums.ReferenceType): OpView => {
        const activeViews: OpView[] = this.getActiveViewsLocal()

        if (activeViews == null) {
            return null
        }

        let activeView: OpView = null
        const filterResult: OpView[] = activeViews.filter((activeView: OpView) => activeView.idReferenceType === referenceType)

        if (filterResult.length > 0) {
            activeView = filterResult[0]
        }
        else {
            console.warn(`Unable to load the view for reference type ${Enums.ReferenceType[referenceType]} locally.`)
        }

        return activeView
    }

    //#endregion
}
